import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { BUSINESS } from "@/data/site";
import { Reveal, Eyebrow } from "@/components/motion";

const CTASection = ({
  title = "Need an Electrician?",
  sub = "Talk to LAD CO Electrical about your residential, commercial or industrial electrical requirements.",
}) => (
  <section className="bg-ink dot-texture relative overflow-hidden" data-testid="cta-section">
    <div className="container-site py-20 lg:py-28">
      <Reveal>
        <Eyebrow dark>Get In Touch</Eyebrow>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight text-white mt-4 max-w-3xl leading-[1.05]">
          {title}
        </h2>
        <p className="text-gray-400 text-base sm:text-lg mt-5 max-w-2xl leading-relaxed">{sub}</p>
        <div className="flex flex-col sm:flex-row gap-4 mt-10">
          <Link to="/quote" className="btn-volt" data-testid="cta-quote-button">
            Request a Quote <ArrowRight className="w-4 h-4" />
          </Link>
          <a href={BUSINESS.phoneHref} className="btn-ghost-light" data-testid="cta-call-button">
            <Phone className="w-4 h-4" /> Call {BUSINESS.phone}
          </a>
        </div>
      </Reveal>
    </div>
    <div className="absolute -right-20 -bottom-24 font-heading font-extrabold uppercase text-[16rem] leading-none text-white/[0.03] select-none pointer-events-none hidden lg:block">
      L2
    </div>
  </section>
);

export default CTASection;
